var React = require('react');

function Export (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.25 12.917V22.0837H1V4.66699H12V6.50033H2.83333V20.2503H18.4167V12.917H20.25ZM23 1.91699H12.9277L16.6264 5.58366L10.2308 12.0645L12.8232 14.6568L19.2188 8.17599L23 12.0003V1.91699Z","fill":"currentColor"}));
}

Export.defaultProps = {"viewBox":"0 0 24 24","fill":"none","style":{"color":"#39424A"}};

module.exports = Export;

Export.default = Export;
